module.exports = __webpack_public_path__ + "fonts/fa-regular-400.ce76b7a.woff2";